import { useEffect, useState } from "react";
import moment from "moment";
import MainLayout from "../layout/main";
import Schema from "../type/schema";
import { deleteCustomer } from "../service/callAPI";
import Card from "../component/card";
import { DataTable } from "../component/DataTable2";
import { CustomerStore } from "../service/db";
import { objectToFullText } from "../lib/misc";
import { ReloadComponent } from "../component/ReloadComponent";
import { DeleteComponent } from "../component/DeleteComponent";

export default function CustomerListPage() {
	const [refreshTrigger, setRefreshTrigger] = useState(false);
	const [pageCustomers, setPageCustomers] = useState<Schema.Customer[]>([]);
	useEffect(() => {
		loadState();

		async function loadState() {
			const customers = await CustomerStore.getItems();
			const populatedCustomers = customers.map((c) => {
				const formattedCreatedAt = moment
					.unix(+c.createdAt)
					.format("YYYY-MM-DD");
				const formattedDob = c.dob
					? moment.unix(+c.dob).format("YYYY-MM-DD")
					: "";

				const populated = {
					...c,
					formattedCreatedAt,
					formattedDob
				};

				const fullText = objectToFullText(populated);
				return {
					...populated,
					fullText
				};
			});

			setPageCustomers(populatedCustomers);
		}
	}, [refreshTrigger]);
	const [selectedRows, setSelectedRows] = useState<any[]>([]);
	return (
		<MainLayout
			pageTitle="Quản Lý Khách Hàng"
			title="Quản Lý Khách Hàng"
			subTitle="Thêm, xóa, sửa khách hàng..."
		>
			<Card title="Khách hàng">
				<DataTable
					selectableRows
					onSelectedRowsChange={(state) => {
						setSelectedRows(state.selectedRows);
					}}
					pagination
					filterEnabled
					customHeaderComponents={[
						DeleteComponent({
							selectedRows,
							setRefreshTrigger,
							deleteById: async (id: string) => {
								await deleteCustomer(id);
								CustomerStore.removeItem(id);
							}
						}),
						ReloadComponent({ setRefreshTrigger })
					]}
					columns={[
						{
							name: "ID",
							selector: (row) => row.id,
							format: (row) => <a href={`/customer/${row.id}`}>{row.id}</a>,
							sortable: true
						},
						{
							name: "Ngày tạo",
							selector: (row) => row.formattedCreatedAt,
							sortable: true
						},
						{
							name: "Tên",
							selector: (row) => row.name,
							sortable: true
						},
						{
							name: "Điện thoại",
							selector: (row) => row.phone,
							sortable: true
						},
						{
							name: "Ngày sinh",
							selector: (row) => row.formattedDob,
							sortable: true
						},
						{
							name: "Địa chỉ",
							selector: (row) => row.address,
							sortable: true
						}
					]}
					data={pageCustomers}
				/>
			</Card>
		</MainLayout>
	);
}
